import Cookies from 'cookies-js';
import { createBrowserHistory as createHistory } from 'history';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import { Middleware, applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { reducer as formReducer } from 'redux-form';
import logger from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import autoMergeLevel1 from 'redux-persist/es/stateReconciler/autoMergeLevel1';
import { CookieStorage } from 'redux-persist-cookie-storage';
import createSagaMiddleware from 'redux-saga';
import { State } from 'common/interfaces/state';
import { rootReducer as reducers } from '../reducers';
import saga from '../sagas';

const sagaMiddleware = createSagaMiddleware();
const history = createHistory();
const middleware = [routerMiddleware(history) as Middleware, sagaMiddleware];


if (process.env.NODE_ENV === 'development') {
  middleware.push(logger);
}

const rootReducer = combineReducers({
  ...reducers,
  router: routerReducer,
  form: formReducer,
});

Cookies.defaults.domain = window.location.hostname.replace(/^.*((\.[^\.]+){2})/, '$1');
const persistConfig = {
  key: 'kreo_state',
  storage: new CookieStorage(Cookies),
  whitelist: ['persistedStorage'],
  stateReconciler: autoMergeLevel1,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore<State>(
  persistedReducer,
  composeWithDevTools(applyMiddleware(...middleware)),
);

const persistor = persistStore(store);

sagaMiddleware.run(saga);

export { history, store, persistor };
